import { useEffect, useState } from 'react';
import { getGuildLang } from '../api';
import { Language } from '../types';
import { useNavigate } from "react-router-dom";

export function useFetchLang(id: any) {
  const [lang, setLang] = useState<Language>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    getGuildLang(id)
    .then(({ data }) => {
      setLang(data);
    })
    .catch((err) => {
      console.log(err);
      navigate('/')
      setError(err);
    })
    .finally(() => setLoading(false))
  }, [navigate, id]);

  return { lang, error, loading };
}